import { Attributes, LookupBase } from '@singularsystems/neo-core';

export default class DividendSummaryLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    @Attributes.Date()
    public startDate: Date = new Date();

    @Attributes.Float()
    public expectedDividend: number = 0;

    @Attributes.Float()
    public actualDividend: number = 0;

    @Attributes.Integer()
    public unprocessedCount: number = 0;

    @Attributes.Integer()
    public readonly totalCount: number = 0;

    @Attributes.Integer()
    public readonly letterCount: number = 0;

    @Attributes.Integer()
    public readonly exportCount: number = 0;

    // Client only properties / methods

    public get missingLetters() {
        return this.totalCount - this.letterCount;
    }

    public get missingExports() {
        return this.totalCount - this.exportCount;
    }
}